import { Location } from '../types';

export const initialLocations: Location[] = [
  {
    id: '1',
    name: 'Белавежская пушча',
    shortDescription: 'Унікальны запаведнік з старажытнымі дрэвамі і багатай фаўнай',
    description: 'Белавежская пушча - адзін з найстарэйшых запаведнікаў Еўропы, дзе можна ўбачыць рэдкія віды жывёл і раслін. Тут знаходзяцца шматлікія экасцежкі для пешых і веласіпедных прагулак.',
    category: 'eco-trail',
    coordinates: {
      lat: 52.7089,
      lng: 23.8419
    },
    images: [
      'https://images.unsplash.com/photo-1572857321797-d80ccb4cea88',
      'https://images.unsplash.com/photo-1572857321976-49d892a37930',
      'https://images.unsplash.com/photo-1572857321654-c13b5acb0024'
    ]
  },
  {
    id: '2',
    name: 'Браслаўскія азёры',
    shortDescription: 'Маляўнічы комплекс азёр для адпачынку і кемпінгу',
    description: 'Браслаўскія азёры - унікальны прыродны комплекс з больш чым 30 азёрамі. Ідэальнае месца для кемпінгу, рыбалкі і воднага турызму.',
    category: 'camping',
    coordinates: {
      lat: 55.6384,
      lng: 27.0435
    },
    images: [
      'https://images.unsplash.com/photo-1571687949921-1306bfb24f72',
      'https://images.unsplash.com/photo-1571687949847-6a3b6c7f7f10',
      'https://images.unsplash.com/photo-1571687949788-7c2c3a1c7f1a'
    ]
  }
];